// Sentinel UUIDs used by the backend to represent "no selection" or "any"
export const NO_COACH_ID  = "00000000-0000-0000-0000-000000000000"; // "No coach" / "Any boat"
export const ANY_COACH_ID = "00000000-0000-0000-0000-000000000001"; // "Any coach"

export const API_BASE = "https://api.cityswell.com.ua/api";
